<template>
  <O3D layout="root">
    <AmbinetLight :intensity="0.3"></AmbinetLight>
    <DirectionalLight :intensity="0.3"></DirectionalLight>
    <HemisphereLight :intensity="0.3"></HemisphereLight>

    <O3D layout="lightGroup">
      <O3D :px="0" :pz="800" :py="100">
        <PointLight :distance="0" :helper="isDev" :intensity="0.7"></PointLight>
      </O3D>
      <O3D :px="0" :pz="-800" :py="100">
        <PointLight :distance="0" :helper="isDev" :intensity="0.7"></PointLight>
      </O3D>
    </O3D>

    <!-- <CitySky></CitySky> -->

    <O3D :px="-500" :pz="100">
      <O3D :key="item._id" v-for="item in slots" :px="item.px" :pz="item.pz">
        <O3D v-if="item.set === 'placeholder'">
          <TextClicker :py="80" text="按此建立新建築" @clicker="addBuilding({ slot: item })"></TextClicker>
          <CityPlaceHolder :info="item" @clicker="addBuilding({ slot: item })"></CityPlaceHolder>
        </O3D>
        <O3D v-if="item.set !== 'placeholder'">
          <CityAutoBuilding :building="item.set" @edit="addBuilding({ slot: item })"></CityAutoBuilding>
        </O3D>
      </O3D>
    </O3D>

    <UICloseLayer v-show="overlay" @close="overlay = false"></UICloseLayer>
    <UIAddBuilding v-show="overlay === 'add-building'" :shown="overlay === 'add-building'" @close="overlay = false"></UIAddBuilding>
    <UICloseButton v-show="overlay" @close="overlay = false"></UICloseButton>

    <Floor :sx="10" :sz="10"></Floor>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { Color } from 'three'

export default {
  mixins: [
    O3DG2
  ],
  data () {
    return {
      slots: [
        { pz: 0, px: 100, set: 'hospitaltall' },
        { pz: 0, px: 200, set: 'housing' },
        { pz: 0, px: 300, set: 'placeholder' },
        { pz: 0, px: 400, set: 'placeholder' },
        { pz: 0, px: 500, set: 'placeholder' },
        { pz: 0, px: 600, set: 'placeholder' },
        { pz: 0, px: 700, set: 'placeholder' },
        { pz: 0, px: 800, set: 'placeholder' },
        { pz: 0, px: 900, set: 'placeholder' },
        { pz: 0, px: 1000, set: 'placeholder' },

        { pz: -200, px: 100, set: 'hospital' },
        { pz: -200, px: 200, set: 'office' },
        { pz: -200, px: 300, set: 'placeholder' },
        { pz: -200, px: 400, set: 'placeholder' },
        { pz: -200, px: 500, set: 'placeholder' },
        { pz: -200, px: 600, set: 'placeholder' },
        { pz: -200, px: 700, set: 'placeholder' },
        { pz: -200, px: 800, set: 'placeholder' },
        { pz: -200, px: 900, set: 'placeholder' },
        { pz: -200, px: 1000, set: 'placeholder' }
      ],
      current: {
        slot: false
      },
      overlay: false,
      layouts: {}
    }
  },
  watch: {
  },
  methods: {
    addBuilding ({ slot }) {
      this.current.slot = slot
      this.overlay = 'add-building'
      this.$once('close-area', () => {
        this.overlay = ''
      })
    },
    async setup () {
      this.onLoop(() => {
        let time = window.performance.now() * 0.001

        this.layouts.lightGroup = {
          ry: time * 0.333
        }

        this.layouts.root = {
          sx: 0.4,
          sy: 0.4,
          sz: 0.4
        }
      })
    }
  },
  mounted () {
    this.setup()

    // this.ctx.scene.rotation.y = this.pi * 0.25
    this.ctx.scene.background = new Color('#272727')

    window.addEventListener('keydown', (evt) => {
      if (evt.keyCode === 27) {
        this.$emit('close-area')
      }
    })
  }
}
</script>

<style>

</style>